import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import apiService from '../../Auth/apiService';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import { FaUsers } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';

const RoleActionsCell = ({ row, onEdit }) => (
    <div>
        <button
            onClick={() => onEdit(row)}
            style={{ backgroundColor: 'skyblue' }}
            data-tooltip-id='tooltiparriba'
            data-tooltip-content="Editar"
        >
            <FaUsers />
        </button>
    </div>
);

const FilterComponent = ({ filterText, onFilter, onClear, onNew }) => (
    <div className="d-flex flex-wrap align-items-center gap-2 w-100">
        <input
            type="text"
            className="form-control"
            placeholder="Filtrar por rol, descripción o estado"
            aria-label="Filtrar roles"
            value={filterText}
            onChange={onFilter}
            style={{ maxWidth: '320px' }}
        />
        <button type="button" className="btn btn-outline-secondary" onClick={onClear}>
            Limpiar
        </button>
        <button type="button" className="btn btn-outline-primary" onClick={onNew}>
            Nuevo
        </button>
    </div>
);

const buildColumns = (handleEdit) => [
    {
        name: 'Acciones',
        cell: row => <RoleActionsCell row={row} onEdit={handleEdit} />,
        ignoreRowClick: true,
        width: '7%'
    },
    { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
    { name: 'Rol', selector: row => row.rolRol, sortable: true, width: '25%'},
    { name: 'Estado', selector: row => row.rolEstado===1?'Activo':'Inactivo', sortable: true, width: '7%' },
    { name: 'Descripción', selector: row => row.rolDescripcion, sortable: true, width: '12%' }
];

export default function Roles(){
    const { token } = useAuth();
    const [roles, setRoles] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const [filterText, setFilterText] = useState('');
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [swalProps, setSwalProps] = useState({});
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarrol';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar rol', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar rol', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar rol', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('rolRol', '');
        setValue('rolEstado', 0);
        setValue('rolDescripcion', '');
        setMuestraFormulario(false);
    }
    const NuevoRol = () =>  {
        setValue('id', 0);
        setValue('rolRol', '');
        setValue('rolEstado', 0);
        setValue('rolDescripcion', '');
        setMuestraFormulario(true);
    }

    function handleEdit (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('rolRol', row.rolRol);
        setValue('rolEstado', row.rolEstado === 1);
        setValue('rolDescripcion', row.rolDescripcion);
    };
    const filteredRoles = roles.filter((row) => {
        const searchText = filterText.toLowerCase();
        const estado = row.rolEstado === 1 ? 'activo' : 'inactivo';
        return (
            row.rolRol?.toLowerCase().includes(searchText) ||
            row.rolDescripcion?.toLowerCase().includes(searchText) ||
            estado.includes(searchText)
        );
    });

    const columns = buildColumns(handleEdit);

    const fetchData = async () => {
        let url = '/parametros/listarroles';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setRoles(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };

    useEffect(() => {
        fetchData();
        }, []);

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Roles</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/parametros`} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Rol</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario rol</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='rolRol'>Rol</label>
                                                <input id='rolRol' {...register('rolRol', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Rol"/>
                                                {errors.rolRol && <p style={{color: 'red'}}>Digitar rol</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='rolDescripcion'>Descripci&oacute;n</label>
                                                <input id='rolDescripcion' {...register('rolDescripcion')} 
                                                    className="form-control" 
                                                    placeholder="Descripción"/>
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('rolEstado')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <FilterComponent
                                    filterText={filterText}
                                    onFilter={(e) => setFilterText(e.target.value)}
                                    onClear={() => setFilterText('')}
                                    onNew={NuevoRol}
                                />
                                <table className="table table-hover text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th>Id</th>
                                            <th>Rol</th>
                                            <th>Estado</th>
                                            <th>Descripci&oacute;n</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredRoles.map((role) => (
                                            <tr key={role.id}>
                                                <td>
                                                    <RoleActionsCell row={role} onEdit={handleEdit} />
                                                </td>
                                                <td>{role.id}</td>
                                                <td>{role.rolRol}</td>
                                                <td>{role.rolEstado === 1 ? 'Activo' : 'Inactivo'}</td>
                                                <td>{role.rolDescripcion}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </div>
    );
}